/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteUserSessionIssuerCimdClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteUserSessionIssuerCimdClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteUserSessionIssuerCimdClientSecurity = {
  option1?: DeleteUserSessionIssuerCimdClientSecurityOption1 | undefined;
  option2?: DeleteUserSessionIssuerCimdClientSecurityOption2 | undefined;
};

export type DeleteUserSessionIssuerCimdClientRequest = {
  /**
   * The user_session_issuer_cimd_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteUserSessionIssuerCimdClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteUserSessionIssuerCimdClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerCimdClientSecurityOption1$Outbound,
    DeleteUserSessionIssuerCimdClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteUserSessionIssuerCimdClientSecurityOption1ToJSON(
  deleteUserSessionIssuerCimdClientSecurityOption1:
    DeleteUserSessionIssuerCimdClientSecurityOption1,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerCimdClientSecurityOption1$outboundSchema.parse(
      deleteUserSessionIssuerCimdClientSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerCimdClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteUserSessionIssuerCimdClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerCimdClientSecurityOption2$Outbound,
    DeleteUserSessionIssuerCimdClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteUserSessionIssuerCimdClientSecurityOption2ToJSON(
  deleteUserSessionIssuerCimdClientSecurityOption2:
    DeleteUserSessionIssuerCimdClientSecurityOption2,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerCimdClientSecurityOption2$outboundSchema.parse(
      deleteUserSessionIssuerCimdClientSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerCimdClientSecurity$Outbound = {
  Option1?:
    | DeleteUserSessionIssuerCimdClientSecurityOption1$Outbound
    | undefined;
  Option2?:
    | DeleteUserSessionIssuerCimdClientSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const DeleteUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerCimdClientSecurity$Outbound,
    DeleteUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        DeleteUserSessionIssuerCimdClientSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        DeleteUserSessionIssuerCimdClientSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function deleteUserSessionIssuerCimdClientSecurityToJSON(
  deleteUserSessionIssuerCimdClientSecurity:
    DeleteUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      deleteUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type DeleteUserSessionIssuerCimdClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    DeleteUserSessionIssuerCimdClientRequest$Outbound,
    DeleteUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function deleteUserSessionIssuerCimdClientRequestToJSON(
  deleteUserSessionIssuerCimdClientRequest:
    DeleteUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    DeleteUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      deleteUserSessionIssuerCimdClientRequest,
    ),
  );
}
